module.exports = __webpack_public_path__ + "static/media/double-arrow.bec56693.png";